import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-center-section',
  templateUrl: './help-center-section.component.html',
  styleUrls: ['./help-center-section.component.scss']
})
export class HelpCenterSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
